// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1141":"615e6f38603663ea","6037":"249054fcaf9bdd65"}[chunkId] + ".js";
};